"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var HitlApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(HitlApi, _BasicProviderApi);

  /**
   * Represents a Hitl Api.
   * @constructor
   */
  function HitlApi(_ref) {
    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        httpGatewayUrl = _ref.httpGatewayUrl,
        sendWSMessage = _ref.sendWSMessage;
    (0, _classCallCheck2.default)(this, HitlApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HitlApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId,
      httpGatewayUrl: httpGatewayUrl,
      sendWSMessage: sendWSMessage
    }));
  }
  /**
   * @returns {Array} list of active hitl sessions
   */


  (0, _createClass2.default)(HitlApi, [{
    key: "getHitlSessionsList",
    value: function () {
      var _getHitlSessionsList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _ref2,
            size,
            from,
            sort,
            scroll,
            scroll_id,
            projection,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, size = _ref2.size, from = _ref2.from, sort = _ref2.sort, scroll = _ref2.scroll, scroll_id = _ref2.scroll_id, projection = _ref2.projection;
                _context.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/sessions',
                  queryParams: {
                    size: size,
                    from: from,
                    sort: sort,
                    scroll: scroll,
                    scroll_id: scroll_id,
                    projection: projection
                  },
                  errorName: 'HitlSessionError'
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getHitlSessionsList() {
        return _getHitlSessionsList.apply(this, arguments);
      }

      return getHitlSessionsList;
    }()
    /**
     * @returns {Object} hitl session
     */

  }, {
    key: "getHitlSessionById",
    value: function () {
      var _getHitlSessionById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref3) {
        var hitlSessionId, projection;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hitlSessionId = _ref3.hitlSessionId, projection = _ref3.projection;
                _context2.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/sessions',
                  queryParams: {
                    hitlSessionId: hitlSessionId,
                    projection: projection
                  },
                  errorName: 'HitlSessionError'
                });

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getHitlSessionById(_x) {
        return _getHitlSessionById.apply(this, arguments);
      }

      return getHitlSessionById;
    }()
    /**
     *
     * @param {String} param0.contactId id of contact
     * @returns {Array} of closed conversations for this contact id
     */

  }, {
    key: "getHitlSessionsHistoryByContactId",
    value: function () {
      var _getHitlSessionsHistoryByContactId = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref4) {
        var contactId, size, from, sort, scroll, scroll_id, projection;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contactId = _ref4.contactId, size = _ref4.size, from = _ref4.from, sort = _ref4.sort, scroll = _ref4.scroll, scroll_id = _ref4.scroll_id, projection = _ref4.projection;
                _context3.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/sessions',
                  queryParams: {
                    contactId: contactId,
                    closed: true,
                    size: size,
                    from: from,
                    sort: sort,
                    scroll: scroll,
                    scroll_id: scroll_id,
                    projection: projection
                  },
                  errorName: 'HitlSessionError'
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getHitlSessionsHistoryByContactId(_x2) {
        return _getHitlSessionsHistoryByContactId.apply(this, arguments);
      }

      return getHitlSessionsHistoryByContactId;
    }()
    /**
     *
     * @param {String} param0.searchData need to contain at least 'contact', 'searchPhrase', 'dateRange' or 'tags'
     * @returns {Array} of found hitl sessions and contacts lists
     */

  }, {
    key: "searchHitlSessions",
    value: function () {
      var _searchHitlSessions = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref5) {
        var searchData;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                searchData = _ref5.searchData;
                _context4.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/hitl/sessions/search',
                  payload: searchData,
                  errorName: 'HitlSessionError'
                });

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function searchHitlSessions(_x3) {
        return _searchHitlSessions.apply(this, arguments);
      }

      return searchHitlSessions;
    }()
    /**
     *
     * @param {String} param0.hitlSessionId id of hitl session
     * @returns {Array} of events for this hitl session
     */

  }, {
    key: "getEventsByHitlSessionId",
    value: function () {
      var _getEventsByHitlSessionId = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref6) {
        var hitlSessionId;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                hitlSessionId = _ref6.hitlSessionId;
                _context5.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/sessions/events',
                  queryParams: {
                    hitlSessionId: hitlSessionId
                  },
                  errorName: 'HitlSessionError'
                });

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getEventsByHitlSessionId(_x4) {
        return _getEventsByHitlSessionId.apply(this, arguments);
      }

      return getEventsByHitlSessionId;
    }()
    /**
     *
     * @param {String} param0.hitlSessionId id of hitl session
     * @param {String} param1.command name of command
     * @param {Object} param2.params command params, e.g. message
     * @param {String} param3.accountId accountId for cross-account requests
     * @param {Number} param4.v api version
     */

  }, {
    key: "invokeCommand",
    value: function () {
      var _invokeCommand = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref7) {
        var hitlSessionId, command, params, accountId, v;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                hitlSessionId = _ref7.hitlSessionId, command = _ref7.command, params = _ref7.params, accountId = _ref7.accountId, v = _ref7.v;
                _context6.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/hitl/commands',
                  payload: {
                    hitlSessionId: hitlSessionId,
                    command: command,
                    params: params,
                    accountId: accountId,
                    v: v
                  },
                  errorName: 'HitlCommandsError'
                });

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function invokeCommand(_x5) {
        return _invokeCommand.apply(this, arguments);
      }

      return invokeCommand;
    }()
    /**
     *
     * @param {Object} param0.callback event manager callback for websockets
     * @param {Array} param1.hitlSessionsIds list of hitl sessions ids that opened by agent
     * @param {Array} param2.type type of hitl listener - callback or event
     */

  }, {
    key: "addListener",
    value: function () {
      var _addListener = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref8) {
        var callback, hitlSessionsIds, type, v;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                callback = _ref8.callback, hitlSessionsIds = _ref8.hitlSessionsIds, type = _ref8.type, v = _ref8.v;
                _context7.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/hitl/subscribe',
                  payload: {
                    callback: callback,
                    hitlSessionsIds: hitlSessionsIds,
                    type: type,
                    v: v
                  },
                  errorName: 'HitlListenerError'
                });

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addListener(_x6) {
        return _addListener.apply(this, arguments);
      }

      return addListener;
    }()
    /**
     *
     * @param {Object} param0.callbackName event manager callback name for websockets
     */

  }, {
    key: "removeListener",
    value: function () {
      var _removeListener = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref9) {
        var callbackName;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                callbackName = _ref9.callbackName;
                _context8.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/hitl/subscribe',
                  queryParams: {
                    callbackName: callbackName
                  },
                  errorName: 'HitlListenerError'
                });

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function removeListener(_x7) {
        return _removeListener.apply(this, arguments);
      }

      return removeListener;
    }()
    /**
     *
     * @param {Array} param0.callbackName event manager callback for websockets
     * @param {Array} param1.hitlSessionsIds list of hitl sessions ids that opened by agent
     */

  }, {
    key: "updateListenerHitlSessions",
    value: function () {
      var _updateListenerHitlSessions = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref10) {
        var callbackName, hitlSessionsIds;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                callbackName = _ref10.callbackName, hitlSessionsIds = _ref10.hitlSessionsIds;
                _context9.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/hitl/subscribe',
                  payload: {
                    callbackName: callbackName,
                    hitlSessionsIds: hitlSessionsIds
                  },
                  errorName: 'HitlListenerError'
                });

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateListenerHitlSessions(_x8) {
        return _updateListenerHitlSessions.apply(this, arguments);
      }

      return updateListenerHitlSessions;
    }()
    /**
     *
     * @param {String} param0.userId agent id
     * @param {String} param1.hitlSessionId id of hitl session
     * @param {String} param2.lastReadEventId event id of last read message
     * @param {String} param3.timestamp timestamp of last read message
     */

  }, {
    key: "saveLastReadMessage",
    value: function () {
      var _saveLastReadMessage = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref11) {
        var hitlSessionId, lastReadEventId, timestamp;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                hitlSessionId = _ref11.hitlSessionId, lastReadEventId = _ref11.lastReadEventId, timestamp = _ref11.timestamp;
                _context10.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/hitl/count-events',
                  payload: {
                    hitlSessionId: hitlSessionId,
                    lastReadEventId: lastReadEventId,
                    timestamp: timestamp
                  },
                  errorName: 'HitlReadMessageError'
                });

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function saveLastReadMessage(_x9) {
        return _saveLastReadMessage.apply(this, arguments);
      }

      return saveLastReadMessage;
    }()
    /**
     *
     * @param {String} param0.userId agent id
     * @param {Array} param1.hitlSessionIds ids of hitl sessions to find unread messages
     * @returns {Object} ammount of unread messages for every hitl session
     */

  }, {
    key: "getUnreadMessagesAmount",
    value: function () {
      var _getUnreadMessagesAmount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref12) {
        var hitlSessionIds;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                hitlSessionIds = _ref12.hitlSessionIds;
                _context11.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/count-events',
                  queryParams: {
                    hitlSessionIds: hitlSessionIds
                  },
                  errorName: 'HitlReadMessageError'
                });

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getUnreadMessagesAmount(_x10) {
        return _getUnreadMessagesAmount.apply(this, arguments);
      }

      return getUnreadMessagesAmount;
    }()
    /**
     *
     * @returns {Array} deployments
     */

  }, {
    key: "getInitSessionsEvents",
    value: function () {
      var _getInitSessionsEvents = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12() {
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/sessions/init',
                  errorName: 'HitlSessionError'
                });

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getInitSessionsEvents() {
        return _getInitSessionsEvents.apply(this, arguments);
      }

      return getInitSessionsEvents;
    }()
    /**
     *
     * @param {String} param0.hitlSessionId id of hitl session
     * @returns {Array} members list
     */

  }, {
    key: "getConferenceMembers",
    value: function () {
      var _getConferenceMembers = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref13) {
        var hitlSessionId;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                hitlSessionId = _ref13.hitlSessionId;
                _context13.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/conferences/members',
                  queryParams: {
                    hitlSessionId: hitlSessionId
                  },
                  errorName: 'HitlConferenceError'
                });

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getConferenceMembers(_x11) {
        return _getConferenceMembers.apply(this, arguments);
      }

      return getConferenceMembers;
    }()
    /**
     * @param {String} param0.hitlSessionId id of hitl session
     * @param {String} param1.memberId id of conference member
     * @returns {Object} filter
     */

  }, {
    key: "getConferenceMember",
    value: function () {
      var _getConferenceMember = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref14) {
        var hitlSessionId, memberId;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                hitlSessionId = _ref14.hitlSessionId, memberId = _ref14.memberId;
                _context14.next = 3;
                return this._callApi({
                  method: 'get',
                  path: '/hitl/conferences/members',
                  queryParams: {
                    hitlSessionId: hitlSessionId,
                    memberId: memberId
                  },
                  errorName: 'HitlConferenceError'
                });

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getConferenceMember(_x12) {
        return _getConferenceMember.apply(this, arguments);
      }

      return getConferenceMember;
    }()
    /**
     * @param {String} param0.hitlSessionId id of hitl session
     * @param {String} param1.memberId id of conference member
     * @param {String} param2.identifier conference member identifier (agentId, contactId, phoneNumber)
     * @param {String} param3.status conference member status
     * @param {String} param4.type conference member type
     * @param {Object} param5.state conference member state (hold, muted)
     * @returns {Object} added conference member
     */

  }, {
    key: "addConferenceMember",
    value: function () {
      var _addConferenceMember = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref15) {
        var hitlSessionId, memberId, identifier, status, type, state;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                hitlSessionId = _ref15.hitlSessionId, memberId = _ref15.memberId, identifier = _ref15.identifier, status = _ref15.status, type = _ref15.type, state = _ref15.state;
                _context15.next = 3;
                return this._callApi({
                  method: 'post',
                  path: '/hitl/conferences/members',
                  payload: {
                    hitlSessionId: hitlSessionId,
                    memberId: memberId,
                    identifier: identifier,
                    status: status,
                    type: type,
                    state: state
                  },
                  errorName: 'HitlConferenceError'
                });

              case 3:
                return _context15.abrupt("return", _context15.sent);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function addConferenceMember(_x13) {
        return _addConferenceMember.apply(this, arguments);
      }

      return addConferenceMember;
    }()
    /**
     * @param {String} param0.hitlSessionId id of hitl session
     * @param {String} param1.memberId id of conference member
     * @param {String} param2.status conference member status
     * @param {Object} param3.state conference member state (hold, muted)
     * @param {String} param4.disconnectedAt timestamp of member disconnect
     * @returns {Object} update stats
     */

  }, {
    key: "updateConferenceMember",
    value: function () {
      var _updateConferenceMember = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(_ref16) {
        var hitlSessionId, memberId, status, state, disconnectedAt;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                hitlSessionId = _ref16.hitlSessionId, memberId = _ref16.memberId, status = _ref16.status, state = _ref16.state, disconnectedAt = _ref16.disconnectedAt;
                _context16.next = 3;
                return this._callApi({
                  method: 'put',
                  path: '/hitl/conferences/members',
                  payload: {
                    hitlSessionId: hitlSessionId,
                    memberId: memberId,
                    status: status,
                    state: state,
                    disconnectedAt: disconnectedAt
                  },
                  errorName: 'HitlConferenceError'
                });

              case 3:
                return _context16.abrupt("return", _context16.sent);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateConferenceMember(_x14) {
        return _updateConferenceMember.apply(this, arguments);
      }

      return updateConferenceMember;
    }()
    /**
     * @param {String} param0.hitlSessionId id of hitl session
     * @param {String} param1.memberId id of conference member
     * @returns {Object} delete stats
     */

  }, {
    key: "deleteConferenceMember",
    value: function () {
      var _deleteConferenceMember = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(_ref17) {
        var hitlSessionId, memberId;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                hitlSessionId = _ref17.hitlSessionId, memberId = _ref17.memberId;
                _context17.next = 3;
                return this._callApi({
                  method: 'delete',
                  path: '/hitl/conferences/members',
                  queryParams: {
                    hitlSessionId: hitlSessionId,
                    memberId: memberId
                  },
                  errorName: 'HitlConferenceError'
                });

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function deleteConferenceMember(_x15) {
        return _deleteConferenceMember.apply(this, arguments);
      }

      return deleteConferenceMember;
    }()
  }]);
  return HitlApi;
}(_basic_provider.default);

var _default = HitlApi;
exports.default = _default;